import { atom } from 'recoil';

const filterMealSearchForm = atom<{
  storeIds: Array<string>;
  tags: Array<string>;
  searchText: string;
}>({
  key: 'filterMealSearchForm',
  default: {
    storeIds: [],
    tags: [],
    searchText: '',
  },
});

export default filterMealSearchForm;
